import { render, staticRenderFns } from "./userResourceNeedMessage.vue?vue&type=template&id=4a95d418&scoped=true&"
import script from "./userResourceNeedMessage.vue?vue&type=script&lang=js&"
export * from "./userResourceNeedMessage.vue?vue&type=script&lang=js&"
import style0 from "./userResourceNeedMessage.vue?vue&type=style&index=0&id=4a95d418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a95d418",
  null
  
)

export default component.exports